export default __webpack_public_path__ + "static/media/4photo(new).04035a57.jpg";